import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-skeleton-table',
  templateUrl: './skeleton-table.component.html',
  imports: [NgxSkeletonLoaderModule, NgClass],
})
export class SkeletonTableComponent implements OnInit {
  @Input() columnCount = 10;
  @Input() showFilters = true;
  @Input() showTabs = true;
  tableRowsCount!: number[];

  ngOnInit() {
    this.tableRowsCount = Array(this.columnCount).fill(0);
  }
}
